import { makeAutoObservable, reaction } from "mobx";
export class FulfillmentFormReactions {
    constructor(params) {
        this.fulfillmentTime = params.fulfillmentTime;
        this.fulfillmentFormController = params.fulfillmentFormController;
        makeAutoObservable(this);
    }
    initialize() {
        if (this._disposer) {
            throw new Error("FulfillmentFormReactions has been already initialized");
        }
        this._disposer = reaction(() => this.fulfillmentTime.type === "Online" && this.fulfillmentTime.options, () => {
            if (this.fulfillmentFormController.type === "Online" &&
                this.fulfillmentTime.type === "Online" &&
                this.fulfillmentTime.domain !== null) {
                // NOTICE: Clear unavailable fulfillment time value in the controller & domain
                // We want to clear it because fulfillment time option is not visible when unavailable (even if selected) and there is no place to display error message.
                if (this.fulfillmentTime.availability.isAvailable.isDefinitelyFalse) {
                    this.fulfillmentFormController.fulfillmentTimeController.clear();
                }
                // NOTICE Controller reactivbity fix:
                // Update controller `fulfillmentOption` value to reflect the domain value (eg. "today" option have a today value and the "in future" option may have today value too)
                for (const option of this.fulfillmentTime.options) {
                    if (option.isActive) {
                        this.fulfillmentFormController.fulfillmentTimeController.fields.fulfillmentOption.change(option.type);
                    }
                }
            }
        }, { fireImmediately: true });
    }
    dispose() {
        if (this._disposer) {
            this._disposer();
        }
    }
}
